<template>
  <v-app>
    <toolbar :title="title" :loaded="loaded"></toolbar>
    <navigation></navigation>

    <v-content>
      <v-container v-if="!loaded" fluid fill-height>
        <v-layout justify-center="justify-center" align-center="align-center">
          <v-progress-circular indeterminate="indeterminate" :size="150" :width="1"
                               color="primary"></v-progress-circular>
        </v-layout>
      </v-container>
      <!--v-slide-x-transition(v-else) keep-alive-->
      <router-view v-else style="padding-bottom: 70px !important;"></router-view>

      <v-footer height="auto" absolute="absolute" dark="dark">
        <v-layout justify-center="justify-center" row="row" wrap="wrap">
          <v-btn color="white" flat="flat" round="round" href="/impress">Impressum</v-btn>
          <!--<v-btn color="white" flat="flat" round="round" @click="$router.push('/conditions')">AGB</v-btn>-->
          <v-btn color="white" flat="flat" round="round" href="/privacy">Datenschutz</v-btn>
        </v-layout>
      </v-footer>
    </v-content>

    <v-dialog v-model="dialogs.confirm.active" :persistent="true" max-width="600px">
      <v-card>
        <v-card-title class="headline" v-text="dialogs.confirm.headline"></v-card-title>
        <v-card-text v-text="dialogs.confirm.text"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="confirmDialogClosed(false)" v-t="'cancel'"></v-btn>
          <v-btn color="green darken-1" flat @click.native="confirmDialogClosed(true)" v-t="'confirm'"></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogs.info.active" max-width="600px">
      <v-card>
        <v-card-title><strong v-text="dialogs.info.headline"></strong></v-card-title>
        <v-card-text>
          <div v-html="dialogs.info.text"></div>
          <br v-if="dialogs.info.copyTitle"/>
          <div v-if="dialogs.info.copyText"><strong v-if="dialogs.info.copyTitle"
                                                    v-text="dialogs.info.copyTitle"></strong>
            <v-textarea class="pt-0" auto-grow readonly v-model="dialogs.info.copyText"></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
              v-for="action in dialogs.info.actions"
              :key="action.label"
              @click="action.handler(); dialogs.info.active=false"
              color="blue darken-1"
              flat
          >{{ action.label }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.stop="dialogs.info.active=false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar :timeout="snackBar.timeout" :color="snackBar.color" bottom v-model="snackBar.active">{{ snackBar.text }}
      <v-btn dark flat @click.native="snackBar.active = false" v-t="'close'"></v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Vue from 'vue';
import Toolbar from './Toolbar';
import Navigation from './Navigation';
import ConfirmationDialog from './dialogs/ConfirmationDialog';
import {mapState} from 'vuex';

export default {
  components: {
    Toolbar,
    Navigation,
    ConfirmationDialog
  },
  data() {
    return {
      loading: false
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    loaded: function () {
      return !this.loading &&
          (this.user === null ||
              (
                  this.dancers.loaded &&
                  this.starterTemplates.loaded &&
                  this.registrations.loaded &&
                  this.events.loaded &&
                  this.starters.loaded
              )
          );
    },
    ...mapState(['user', 'users', 'dialogs', 'starters', 'starterTemplates', 'dancers', 'registrations', 'events', 'snackBar'])
  },
  created() {
    Vue.prototype.$logout = this.logout;
    Vue.prototype.$setDrawer = (state) => {
      this.drawer = state;
    };
    Vue.prototype.$needDancersBirthday = this.needDancersBirthday;
    Vue.prototype.$isIOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    axios.interceptors.response.use(response => {
      // Do something with response data
      return response;
    }, error => {
      if (error.response.data.hasOwnProperty('success') && !error.response.data.success && error.response.data.hasOwnProperty('message')) {
        this.$store.commit('snackBar', {
          color: 'error',
          text: this.$t(`errors.${error.response.data.message}`)
        });
      }
      return Promise.reject(error);
    });

    let user = localStorage.getItem('user');
    if (!user) {
      let allowed = [
        'register',
        'reset-password',
        'impress',
        'privacy'
      ];
      let path = this.$router.currentRoute.path;

      let redirect = _.every(allowed, site => !path.includes(site));

      if (redirect) {
        this.$router.push('/login');
      }

      this.loading = false;

      return;
    }

    user = JSON.parse(user);

    if (user.hasOwnProperty('real_api_token')) {
      this.checkToken(user.real_api_token, () => {
        this.checkToken(user.api_token, () => {
          this.$store.dispatch('login', user);

          if (this.$router.currentRoute.path === '/') {
            this.$router.push('/user/' + (this.user.valid ? 'dashboard' : 'welcome'));
          }

          this.loading = false;
        });
      });
    } else {
      this.checkToken(user.api_token, () => {
        this.$store.dispatch('login', user);

        if (this.$router.currentRoute.path === '/') {
          this.$router.push('/user/' + (this.user.valid ? 'dashboard' : 'welcome'));
        }

        this.loading = false;
      });
    }
  },
  methods: {
    confirmDialogClosed(confirmed) {
      this.dialogs.confirm.active = false;

      if (confirmed && this.dialogs.confirm.confirmCallback !== undefined) {
        this.dialogs.confirm.confirmCallback();
      } else if (!confirmed && this.dialogs.confirm.cancelCallback) {
        this.dialogs.confirm.cancelCallback();
      }

      this.dialogs.confirm.cancelCallback = null;
      this.dialogs.confirm.confirmCallback = null;
    },
    logout() {
      this.$store.dispatch('logout');

      this.$router.push('/login');
    },
    needDancersBirthday(starter) {
      let dancers = [];
      if (starter !== undefined) {
        dancers = starter.dancers;
      } else {
        dancers = this.dancers.items;
      }

      let needs = false;
      dancers.forEach(dancer => {
        if (dancer.needs_birthday) {
          needs = true;
          return false;
        }
      });

      return needs;
    },
    checkToken(token, callback) {
      axios.get(`/api/v1/token/valid/${token}`).then(response => {
        if (!response.data.success) {
          return;
        }

        if (response.data.data.needs_refresh) {
          this.logout();
          return;
        }

        if (callback !== undefined) {
          callback(response);
        }
      }, errorResponse => {
        console.error(errorResponse);
      });
    }
  }
}
</script>
